import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import { swrPaginatedListConfig } from '@shared/api/swr/list-config';

const DEFAULT_LIMIT = 20;

const toPaginationNumber = (value: unknown, fallback: number) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const useAccountings = (page = 1, limit = DEFAULT_LIMIT) => {
  const { data, error, isLoading, mutate } = useSWR(
    swrKeys.accounting.all({ page, limit }),
    swrPaginatedListConfig,
  );

  const pagination = data?.pagination
    ? {
        page: toPaginationNumber(data.pagination.page, page),
        limit: toPaginationNumber(data.pagination.limit, limit),
        total: toPaginationNumber(data.pagination.total, 0),
      }
    : { page, limit, total: 0 };

  return {
    operations: data?.data ?? [],
    pagination,
    isLoading: isLoading && !data,
    error,
    mutate,
  };
};
